import React, { useState } from "react";

const RCN = () => {
  const [activeTab, setActiveTab] = useState("about");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="college-details-container">
      {/* Page Title */}
      <header className="college-header">
        <h1 className="college-title">Rama School of Nursing</h1>
        <p className="college-subtitle">
          Affiliated with recognized institutions for Nursing and Medical programs.
        </p>
      </header>

      {/* Tabs Navigation */}
      <div className="college-tabs">
        <button
          className={`college-tab-button ${activeTab === "about" ? "active" : ""}`}
          onClick={() => handleTabClick("about")}
        >
          About the Program
        </button>
        
        <button
          className={`college-tab-button ${activeTab === "photos" ? "active" : ""}`}
          onClick={() => handleTabClick("photos")}
        >
          Gallery
        </button>
      </div>

      {/* Tab Content */}
      <div className="college-tab-content">
        {activeTab === "about" && (
          <div className="college-tab-panel">
            <Section
              title="Eligibility Criteria for ANM/MPHW (F) & GNM/Staff Nurse Admission:"
              content={
                <>
                  <p>1. Candidate must have passed Twelfth (10+2) for ANM/MPHW (F) & 10+2 from any stream for GNM/Staff Nurse or its equivalent exam with English & Hindi as compulsory subjects from a recognized board with a minimum 50% Marks for general category and 45% marks for reserved category (SC/BC).</p>
                  <p>2. Married candidates are eligible but should not be pregnant at the time of admission or during the training course.</p>
                  <p>3. Age not less than 16 and not more than 35 years on the date of admission.</p>
                  <p>4. Physically Handicapped candidates are not eligible. The admission form must be filled by the candidate in her own handwriting and must attach the attested copies of all required documents.</p>
                </>
              }
            />
            <Section
              title="Required Documents to be Attached with the Application Form:"
              content={
                <>
                  <p>1. Matric & 10+2 Certificate attested copy for MPHW (F)/ANM & matric & 10+2 certificate attested copy for Staff Nurse/GNM.</p>
                  <p>2. Attested copy of SC/ST/BC Certificate duly certified by the competent authority.</p>
                  <p>3. Three latest Passport Size Photographs.</p>
                  <p>4. Character Certificate from the School/College last attended.</p>
                  <p>5. Medical fitness certificate from an MBBS Doctor.</p>
                  <p>6. An Affidavit by parents/guardian on a Rs. 10/- stamp paper for meeting all financial obligations during the training period.</p>
                </>
              }
            />
            <Section
              title="Uniform:"
              content="All trainees will be required to wear the approved uniform while on duty or in the classroom. The trainees will bear the cost of the uniform."
            />
            <Section
              title="Books:"
              content="The Text Books prescribed by the Rama School of Nursing will be supplied to the students on payment at the current cost."
            />
             <Section
              title="Eligibility to Appear in Final Examination:"
              content={
                <>
                  <p>1. Candidates must have attended not less than three-fourths (75%) of the total classes for each paper (lectures, practicals, and field work).</p>
                  <p>2. Completed the practical training requirements.</p>
                  <p>3. A record of practical experience duly completed and signed by the administrative Head of the School.</p>
                  <p>4. Pursued a regular course of study for a period of at least 18 months for MPHW (F)/ANM and 42 months for Staff Nurse/GNM.</p>
                  <p>5. Met the field experience requirements.</p>
                </>
              }
            />
          </div>
        )}

        

        {activeTab === "photos" && (
          <div className="college-gallery">
            <img src="ybed-thumb.jpg" alt="College Image 1" className="college-gallery-image" />
            <img src="rce2.jpg" alt="College Image 2" className="college-gallery-image" />
          </div>
        )}
      </div>
    </div>
  );
};

// Reusable Section Component
const Section = ({ title, content }) => {
  return (
    <div className="college-section">
      <h3 className="college-section-title">{title}</h3>
      <div className="college-section-content">{content}</div>
    </div>
  );
};

export default RCN;
